'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamUpsell = require('./CamUpsell');

var _CamUpsell2 = _interopRequireDefault(_CamUpsell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamUpsell2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamUpsell/index.js
// module id = 548
// module chunks = 11